export default __webpack_public_path__ + "static/media/TubesRed.a72a0c53.png";